/* eslint-disable */
import { countStageChanges } from '@/Pages/Cooking/Cooking Recipe/cookingRecipe.config';
import { Tooltip } from '@mui/material';

const CookingProcessesTabs = (props) => {
	const { processes = {}, activeStage, setActiveStage, versionDiff } = props;
	return (
		<div className='w-full'>
			<p className='text-xl pb-2'>Cooking Processes</p>
			{Object.entries(processes)?.map(([key, value]) => {
				// eslint-disable-next-line eqeqeq
				const isSelected = key == activeStage;
				const forStages = value?.forStage?.map((stageKey) => {
					return processes?.[stageKey];
				});
				const forStagesProducts = forStages?.map((ele) => {
					return ele?.stageProduct?.productName;
				});
				const forStagesProductsName = forStagesProducts?.join(', ');

				const pastStage = versionDiff?.stages?.items?.[key];
				const isNewStage = !!versionDiff && !pastStage;
				const changeCount = (!isNewStage && pastStage) ? countStageChanges(value, pastStage) : 0;
				const hasChanges = !!versionDiff && (isNewStage || changeCount > 0);
				// This stage's own recipe is awaiting approval — badge it so the
				// pending child is visible at a glance in the tree.
				const isApprovalPending = value?.recipeData?.recipeStatus === 'APPROVAL_PENDING';

				return (
					<div
						key={key}
						onClick={() => {
							setActiveStage(key);
						}}
						className={`bg-gradient-to-r from-[${value?.process?.color ?? ''
							}] rounded-xl p-2 min-w-[275px] cursor-pointer ${isSelected
								? 'rounded-r-none border border-slate-400 font-semibold shadow-inner'
								: ''
							} ${hasChanges ? 'animate-pulse-slow' : ''}`}
						style={{
							background: isSelected
								? `linear-gradient(90deg, ${value?.process?.color ?? '#132a13'
								} 25%, rgba(241,241,241,0.75) 60%)`
								: `linear-gradient(90deg, ${value?.process?.color ?? '#132a13'
								} 0%, rgba(241,241,241,0.75) 10%)`,
						}}
					>
						<div className='w-full h-full bg-white rounded-xl relative p-2 overflow-visible'>
							<div className='absolute top-1 right-1 flex flex-col items-end gap-1'>
								<p className='text-xs text-gray-400 font-medium'>
									v
									{value?.recipeData?.version}
								</p>
								{hasChanges && (
									<Tooltip title={isNewStage ? 'New stage in current version' : `${changeCount} changes detected`}>
										<div className='bg-amber-500 text-white text-[10px] font-bold px-1 py-1 rounded shadow flex items-center gap-1 leading-none uppercase tracking-tighter'>
											<span>{isNewStage ? 'New' : `${changeCount} Changes`}</span>
										</div>
									</Tooltip>
								)}
								{isApprovalPending && (
									<Tooltip title='This recipe version is awaiting approval'>
										<div className='bg-orange-500 text-white text-[10px] font-bold px-1 py-0.5 rounded flex items-center leading-none uppercase tracking-tighter whitespace-nowrap'>
											Approval Pending
										</div>
									</Tooltip>
								)}
							</div>
							<p className={`text-xl bg-blend-color-dodge ${(hasChanges || isApprovalPending) ? 'pr-28' : 'pr-7'}`}>{value?.name}</p>
							<p className='text-sm m-0 text-gray-500'>
								{value?.process?.heading ?? '-'}
							</p>
							{value?.forStage?.length && (
								<div className='flex gap-2 text-sm mt-1'>
									<p className='text-gray-400 font-medium'>For: </p>
									<Tooltip title={forStagesProducts?.join(', ')}>
										<span className='text-gray-600 italic'>
											{forStagesProductsName?.length > 24
												? `${forStagesProductsName?.substring(0, 24)}...`
												: forStagesProductsName}
										</span>
									</Tooltip>
								</div>
							)}
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default CookingProcessesTabs;
